import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { PaginatedResult } from '../../shared/models/paginated-result';
import { AUTH_SERVER_URL } from '../../config';
import { OrderBy } from '../../shared/utils/constant';
import { Organization, organizationInnerFields } from '../models/organization';

const GET_ORGANIZATION_URL = `${ AUTH_SERVER_URL }/v2/organizations:external`;

@Injectable({ providedIn: 'root' })
export class OrganizationService {
	constructor(
		private readonly http: HttpClient
	) {}

	getAllOrganizations(
		fields: string[],
		filter: string | undefined,
		index: number,
		limit: number,
		orderBy: OrderBy<keyof Organization>[] | OrderBy<keyof Organization>,
		onlyDistinct: boolean
	) {
		const newFields: string[] = [
			...fields,
			...organizationInnerFields
		];
		const url = new URL(GET_ORGANIZATION_URL);
		const params = url.searchParams;
		params.append('fields', newFields.join(','));
		if (filter) {
			params.append('filter', filter);
		}
		params.append('page', String(Math.floor(index / limit) + 1));
		params.append('limit', String(limit));

		params.append('orderBy', Array.isArray(orderBy) ? orderBy.join(',') : String(orderBy));

		params.append('distinct', String(onlyDistinct));

		return this.http.get<PaginatedResult<Organization>>(url.toString());
	}
}
